// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // QA
    API_END_POINT: 'https://sr-backend-api.takeleap.in/', //QA backend API  point
    ANTON_API_END_POINT: 'https://sr-backend-api.takeleap.in/', //QA backend API  point
    // API_END_POINT: 'https://python.seekright.com/',//QA backend API  point
    IMS_API_END_POINT: 'https://sr-ims-api.seekright.com/', //QA backend API  point
    AUDIT_API_END_POINT: 'https://sr-audit.takeleap.in/', //QA node backend API  point

    // Local
    // IMS_API_END_POINT: 'http://localhost:3011',  //testing the changes

    // API_END_POINT: 'https://sr-prod-python.seekright.com/',//QA backend API  point
    // API_END_POINT: 'https://python.seekright.com/',
    TRACKING_V2_API_BASE: 'https://tracking-backend.seekright.com',
    googleMapsApiKey: 'AIzaSyDnDb342-Opf1teLJaez3AixgzXD4khuhk',
    // TRACKING_V2_API_BASE: 'http://127.0.0.1:8015',

    mapBoxApiKey:
        'pk.eyJ1IjoicmF2aXRhYWRpMiIsImEiOiJjbTY4emdwZHcwNjVvMmpzZTE5MmY4cmZ6In0.foHg5a0_rCynxXDq0xJG-g',
    ANTON_BASE_URL_VIDEOS:
        'https://auditor-master-images.seekright.com/SeekRight/',
    AWS_S3_BASE_URL_IMAGES: 'https://sr-img.seekright.com/',
    // AWS_S3_BASE_URL_IMAGES: 'https://img-sr.seekright.com/',//UAE backend API point
    NEW_DASHBOARD_URL: 'https://dashboard-new-qa.seekright.com/anomalies',
    googleClientId:
        '830534473071-ob4isnr4rpvela6djsuq0cb2acia3m31.apps.googleusercontent.com',
    mapBoxStyleUrl: 'mapbox://styles/mapbox/streets-v11',
    //marker changed to icon and map changed to satellite view,should be uncommented
    // mapBoxStyleForStreetUrl:'mapbox://styles/mapbox/streets-v11',
    //marker changed to icon and map changed to satellite view,should be uncommented
    // mapBoxStyleForSatelliteUrl:'mapbox://styles/mapbox/satellite-v9'
    // API_END_POINT: 'https://rta-python.seekright.com/', //UAE backend API point
    // AUDIT_API_END_POINT: 'https://rta-node.seekright.com/',//QA node backend API  point
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
